import { render, staticRenderFns } from "./SimpleInternalDataImportModal.vue?vue&type=template&id=7c54ab2f&scoped=true"
import script from "./SimpleInternalDataImportModal.ts?vue&type=script&lang=ts&external"
export * from "./SimpleInternalDataImportModal.ts?vue&type=script&lang=ts&external"
import style0 from "./SimpleInternalDataImportModal.vue?vue&type=style&index=0&id=7c54ab2f&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54ab2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c54ab2f')) {
      api.createRecord('7c54ab2f', component.options)
    } else {
      api.reload('7c54ab2f', component.options)
    }
    module.hot.accept("./SimpleInternalDataImportModal.vue?vue&type=template&id=7c54ab2f&scoped=true", function () {
      api.rerender('7c54ab2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/SimpleInternalDataImportModal.vue"
export default component.exports